// apps/canifight/src/screens/Landing.jsx
import styles from './Landing.module.css';

export default function Landing({ onStart, onSkip }) {
  return (
    <div className={styles.page}>
      <div className={styles.bg} />
      <div className={styles.grid} />
      <div className={styles.content}>
        <div className={styles.tag}>⚔ The Ultimate Showdown Simulator</div>
        <h1 className={styles.logo}>
          CAN I<br /><span>FIGHT</span><br />IT?
        </h1>
        <div className={styles.sub}>Find Out Now</div>
        <p className={styles.desc}>
          Answer a few questions about yourself, pick your opponent, and discover
          exactly how badly — or brilliantly — it goes.
        </p>
        <button className={styles.btnPrimary} onClick={onStart}>
          TAKE THE SURVEY
        </button>
        <button className={styles.btnSecondary} onClick={onSkip}>
          Skip survey — use average human stats
        </button>
      </div>
    </div>
  );
}
